import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ZampassSignOutPage = () => {
    // Hooks for navigation and authentication context
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        // This useEffect block runs once when the component mounts.
        // The browser has just been redirected here by ZamPass after successfully
        // terminating the remote session.
        
        console.log("ZampassSignOutPage: Handling post-logout cleanup...");
        
        // 1. Perform local cleanup (clears JWT, user state, and ZamPass ID Token from localStorage)
        // This is the local 'logout' function you previously defined.
        logout(); 

        // 2. Log confirmation and redirect to the home page
        const redirectTimer = setTimeout(() => {
            console.log("ZampassSignOutPage: Cleanup complete. Redirecting to home.");
            navigate('/', { replace: true });
        }, 1000); // Small delay for the user to see the "Signing out..." message

        // Cleanup function to clear the timeout if the component unmounts early
        return () => clearTimeout(redirectTimer);
    }, [logout, navigate]); // Dependencies ensure useEffect runs correctly

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            backgroundColor: '#f5f5f5' // A neutral background
        }}>
            <h1 style={{ color: '#333' }}>
                👋 Signing Out...
            </h1>
            <p style={{ color: '#666', fontSize: '1.1em' }}>
                Your session with ZamPass has ended. Please wait while we redirect you.
            </p>
        </div>
    );
};

export default ZampassSignOutPage;